// components/ui/Content/ChartComponent2.tsx
'use client';

import {
  ChartContainer,
  ChartLegend,
  ChartTooltip,
  ChartTooltipContent
} from '@/components/ui/chart';

import ChartComponent from './ChartsComponet';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  XAxis,
  YAxis
} from 'recharts';

// components/ui/Content/ChartComponent2.tsx

// Define chart data and options for ChartComponent2
const chartData2 = {
  title: 'Advancements in Synthetic Biology',
  source: 'Sources: Nature Biotechnology, ScienceDirect, PubMed'
};

// Prepare data for the chart, including 2024
const data = [
  { year: '2026', innovations: 105 },
  { year: '2025', innovations: 90 },
  { year: '2024', innovations: 80 },
  { year: '2023', innovations: 75 },
  { year: '2022', innovations: 70 },
  { year: '2021', innovations: 60 },
  { year: '2020', innovations: 50 },
  { year: '2019', innovations: 40 },
  { year: '2018', innovations: 35 },
  { year: '2017', innovations: 30 },
  { year: '2016', innovations: 25 },
  { year: '2015', innovations: 20 },
  { year: '2014', innovations: 15 },
  { year: '2013', innovations: 10 }
];

// Create the chart as a React element
const chart = (
  <ChartContainer
    config={{ Innovations: { label: 'Innovations', color: '#82e482' } }}>
    <BarChart
      data={data}
      layout='vertical'
      margin={{ top: 0, left: -20, right: 30, bottom: 0 }}>
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis
        type='number'
        domain={[0, 'dataMax + 10']}
      />
      <YAxis
        dataKey='year'
        type='category'
      />
      <ChartTooltip content={(props) => <ChartTooltipContent {...props} />} />
      <ChartLegend verticalAlign='top' />
      <Bar
        dataKey='innovations'
        name='Number of Innovations'
        fill='#82e482'>
        <LabelList
          dataKey='innovations'
          position='right'
        />
        {data.map((entry) => (
          <Cell
            key={`cell-${entry.year}`}
            fill={
              entry.innovations === Math.max(...data.map((d) => d.innovations))
                ? '#b580e4'
                : '#82e482'
            }
          />
        ))}
      </Bar>
    </BarChart>
  </ChartContainer>
);

// Main component
export default function ChartComponent2() {
  return (
    <ChartComponent
      data={chartData2} // Pass the data with title and source
      chart={chart} // Pass the chart as a React element
    />
  );
}
